<div class="row-wrapper inactive-registration">
  <div nz-row>
    <div nz-col [nzXs]="23" [nzSm]="23" [nzMd]="21">
      <div class="form-title" [innerHTML]="'NEW_ACCOUNT.REGISTRATION_TEMPORARILY_INACTIVE' | translate"></div>
    </div>
  </div>
  <div nz-row>
    <div nz-col [nzXs]="23" [nzSm]="23" [nzMd]="21">
      <div class="explanation-text" [innerHTML]="'NEW_ACCOUNT.SORRY_COMEBACK_LATER' | translate"></div>
    </div>
  </div>
</div>
